import React, { useEffect } from "react";

import { Switch, Route } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { makeStyles } from "@material-ui/core/styles";
import Navbar from "components/Navbar/Navbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import { dashboardRoutes } from "routes.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import bgImage from "assets/img/Background.png";
import logo from "assets/img/vopa_logo_white.png";
import ChapterParts from "views/CreateChapter/createChapterPart";
import UserDetail from "views/UserProfile/UserDetail";
import CheckingChapterPart from "views/CheckingSection/checkingChapterPart";
import ChapterPreview from "views/ChapterPreview/ChapterPreview";
import CreateChallenge from "views/Challenges/components/CreateChallenge";
import EditChallenge from "views/Challenges/components/EditChallenge";
import CreateMilestone from "views/Milestone/components/CreateMilestone";
import EditMilestone from "views/Milestone/components/EditMilestone";
import CreateNudge from "views/Nudge/components/CreateNudge";
import EditNudge from "views/Nudge/components/EditNudge";
let ps;

const switchRoutes = ({ ...rest }) => (
  <Switch>
    {dashboardRoutes().map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
            {...rest}
          />
        );
      }
      return null;
    })}
    <Route
      path={"/admin/partofchapter"}
      component={ChapterParts}
      // {...rest}
    />
    <Route
      path={"/admin/all-user/:id"}
      component={UserDetail}
      // {...rest}
    />
    <Route
      path={"/admin/partofchapterchecking"}
      component={CheckingChapterPart}
      // {...rest}
    />
    <Route path={"/admin/chapter/preview/:id"} component={ChapterPreview} />
    <Route path={"/admin/challenge/create-challenge"} component={CreateChallenge} />
    <Route path={"/admin/challenge/edit-challenge/:id"} component={EditChallenge} />
    <Route path={"/admin/milestones/create-milestone"} component={CreateMilestone} />
    <Route path={"/admin/milestones/edit-milestone/:id"} component={EditMilestone} />
    <Route path={"/admin/nudges/create-nudge"} component={CreateNudge} />
    <Route path={"/admin/nudges/edit-nudge/:id"} component={EditNudge} />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  // const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      localStorage.clear();
      window.location.href = window.location.origin;
    }
  }, []);

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={dashboardRoutes()}
        logoText={"Vopa"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      {/* <Navbar /> */}
      <div className={classes.mainPanel} ref={mainPanel} id="mainPanel">
        {/* <Navbar
          routes={dashboardRoutes()}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        /> */}
        {getRoute() ? (
          <div style={{ marginTop: 30 }}>
            <div className={classes.container}>{switchRoutes(rest)}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes(rest)}</div>
        )}
      </div>
    </div>
  );
}
